// src/services/questionFactory/providers/index.js
//
// Provider registry. Add new providers here as they come online.

import claudeProvider      from './claudeProvider';
import chatGptProvider     from './chatGptProvider';
import pmiInfinityProvider from './pmiInfinityProvider';
import geminiProvider      from './geminiProvider';

const REGISTRY = {
  claude:       claudeProvider,
  chatgpt:      chatGptProvider,
  pmi_infinity: pmiInfinityProvider,
  gemini:       geminiProvider,
};

/** Return the provider definition for an id, or null if unknown. */
export function getProvider(id) {
  if (!id) return null;
  const key = String(id).toLowerCase().replace(/-/g, '_');
  return REGISTRY[key] || null;
}

/** Return every registered provider (in display order). */
export function listProviders() {
  return [claudeProvider, chatGptProvider, pmiInfinityProvider, geminiProvider];
}

const providerRegistryModule = { getProvider, listProviders };

export default providerRegistryModule;
